/* Motion enhances the page; the entire story remains available without it. */
(()=>{
  const instances=new Map();
  const init=scope=>{
    const items=scope.matches?.('[data-mt-seed]')?[scope]:scope.querySelectorAll('[data-mt-seed]');
    items.forEach(story=>{
      if(instances.has(story))return;
      const controller=new AbortController(),{signal}=controller;
      const scroller=story.closest('.page-wrapper');
      const root=scroller&&/auto|scroll/.test(getComputedStyle(scroller).overflowY)?scroller:null;
      const reduced=matchMedia('(prefers-reduced-motion: reduce)');
      const saveData=Boolean(navigator.connection?.saveData);
      const observers=[];
      const reveals=[...story.querySelectorAll('[data-msd-reveal],[data-mt-reveal]')];
      reveals.forEach(item=>item.setAttribute('data-msd-reveal',''));
      if('IntersectionObserver' in window&&!reduced.matches){
        story.classList.add('msd-enhanced');
        const observer=new IntersectionObserver(entries=>entries.forEach(entry=>{
          if(entry.isIntersecting){entry.target.classList.add('is-visible');observer.unobserve(entry.target)}
        }),{root,threshold:.07,rootMargin:'0px 0px -20px 0px'});
        reveals.forEach(item=>observer.observe(item));observers.push(observer);
      }
      const video=story.querySelector('[data-msd-video]');
      const rest=story.querySelector('[data-msd-rest]');
      const toggle=story.querySelector('[data-msd-toggle]');
      let visible=false,userPaused=reduced.matches||saveData;
      const sync=()=>{
        if(!video||!toggle)return;
        toggle.textContent=video.paused?toggle.dataset.play:toggle.dataset.pause;
        rest.classList.toggle('is-playing',!video.paused);
      };
      const play=()=>{
        const source=video?.querySelector('source[data-src]');
        if(source&&!source.getAttribute('src')){source.src=source.dataset.src;video.load()}
        video?.play().catch(sync);
      };
      const playback=()=>{
        if(!video)return;
        if(visible&&!document.hidden&&!userPaused)play();else video.pause();
      };
      if(video&&toggle){
        video.muted=true;toggle.hidden=false;
        video.addEventListener('play',sync,{signal});video.addEventListener('pause',sync,{signal});
        toggle.addEventListener('click',()=>{userPaused=!video.paused;if(userPaused)video.pause();else play()},{signal});
        if('IntersectionObserver' in window){
          const observer=new IntersectionObserver(entries=>{visible=entries.some(entry=>entry.isIntersecting);playback()},{root,threshold:.03});
          observer.observe(rest);observers.push(observer);
        }else{visible=true;playback()}
        document.addEventListener('visibilitychange',playback,{signal});sync();
      }
      const hero=story.querySelector('.msd-hero');let frame=0;
      const update=()=>{
        frame=0;if(reduced.matches||innerWidth<750||!hero)return;
        const bounds=hero.getBoundingClientRect(),top=root?.getBoundingClientRect().top||0;
        if(bounds.bottom<top||bounds.top>innerHeight)return;
        const progress=Math.max(0,Math.min(1,(top-bounds.top)/bounds.height));
        hero.style.setProperty('--msd-hero-scale',(1.025-progress*.025).toFixed(4));
      };
      const scroll=()=>{if(!frame)frame=requestAnimationFrame(update)};
      (root||window).addEventListener('scroll',scroll,{passive:true,signal});
      window.addEventListener('resize',scroll,{passive:true,signal});
      reduced.addEventListener('change',()=>{if(reduced.matches){reveals.forEach(el=>el.classList.add('is-visible'));userPaused=true;video?.pause();hero?.style.removeProperty('--msd-hero-scale')}},{signal});
      story.querySelectorAll('.msd-scent-detail').forEach(detail=>detail.addEventListener('toggle',()=>{
        if(detail.open)story.querySelectorAll('.msd-scent-detail').forEach(other=>{if(other!==detail)other.open=false});
      },{signal}));
      update();instances.set(story,()=>{controller.abort();observers.forEach(o=>o.disconnect());cancelAnimationFrame(frame);video?.pause()});
    });
  };
  init(document);
  document.addEventListener('shopify:section:load',e=>init(e.target));
  document.addEventListener('shopify:section:unload',e=>{instances.forEach((destroy,node)=>{if(e.target.contains(node)){destroy();instances.delete(node)}})});
})();
